(() => {
  const cartUrl = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format((Number(cents)||0)/100);
  function announce(message, isError=false){
    let toast=document.getElementById('gx-cart-message');
    if(!toast){toast=document.createElement('div');toast.id='gx-cart-message';toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');toast.style.cssText='position:fixed;bottom:18px;right:18px;z-index:9999;background:#151515;color:#fff;border-radius:9px;padding:13px 18px;box-shadow:0 5px 23px #0003;max-width:320px;font-weight:700';document.body.appendChild(toast)}
    toast.textContent=message;toast.style.background=isError?'#a91f43':'#171313';
  }
  async function refreshCart(){
    const response=await fetch(cartUrl+'cart.js',{credentials:'same-origin'});
    if(!response.ok)return;
    const cart=await response.json();
    const label=document.querySelector('.header-icons a[href*="/cart"] span');
    if(label)label.textContent='Basket ('+cart.item_count+')';
  }
  async function sendForm(form,button){
    const old=button.textContent;button.disabled=true;button.textContent='Adding…';
    try{
      const response=await fetch(cartUrl+'cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'},credentials:'same-origin'});
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||'Please check your selection and try again.')}
      await refreshCart();announce('Added to your basket ♡');
    }catch(error){announce(error.message||'Unable to add to basket',true)}
    finally{button.disabled=false;button.textContent=old}
  }
  document.addEventListener('submit',event=>{
    const form=event.target.closest('.gx-main-buy-form, .gx-addon-form, .gx-tile-form');
    if(!form)return;
    if(!form.reportValidity())return;
    const button=form.querySelector('[type="submit"]');
    if(!button||button.disabled)return;
    event.preventDefault();sendForm(form,button);
  });
  const productForm=document.querySelector('#gx-main-product-form');
  if(productForm){
    const variantScript=productForm.querySelector('[data-gx-variants]');
    let variants=[];try{variants=JSON.parse(variantScript?.textContent||'[]')}catch(error){}
    const groups=[...productForm.querySelectorAll('[data-gx-variant-group]')];
    function syncVariant(){
      if(!groups.length)return;
      const selected=groups.map(g=>g.querySelector('input:checked')?.value);
      const variant=variants.find(v=>v.options.length===selected.length&&v.options.every((option,index)=>option===selected[index]));
      const add=productForm.querySelector('[data-gx-main-add]');
      const id=productForm.querySelector('[data-gx-variant-id]');
      if(!add||!id)return;
      if(variant){id.value=variant.id;add.disabled=!variant.available;add.innerHTML=variant.available?'♧ Add to basket – <span data-gx-button-price>'+money(variant.price)+'</span>':'Sold out';const price=document.querySelector('[data-gx-price]');if(price)price.textContent=money(variant.price);const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url.toString())}
      else{add.disabled=true;add.textContent='Unavailable combination'}
    }
    groups.forEach(group=>group.addEventListener('change',syncVariant));
    productForm.querySelectorAll('[data-gx-qty]').forEach(button=>button.addEventListener('click',()=>{
      const input=productForm.querySelector('input[name="quantity"]');if(!input)return;
      input.value=Math.max(1,(parseInt(input.value,10)||1)+(parseInt(button.dataset.gxQty,10)||0));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
  }
  const thumbs=[...document.querySelectorAll('[data-gx-thumb]')];
  const mainImage=document.querySelector('.gx-gallery-focus');
  if(thumbs.length&&mainImage){
    let current=Math.max(0,thumbs.findIndex(button=>button.classList.contains('is-active')));
    const setImage=index=>{
      current=(index+thumbs.length)%thumbs.length;
      const thumb=thumbs[current];
      mainImage.removeAttribute('srcset');mainImage.removeAttribute('sizes');
      mainImage.src=thumb.dataset.gxFull;mainImage.alt=thumb.querySelector('img')?.alt||mainImage.alt;
      thumbs.forEach((b,i)=>{b.classList.toggle('is-active',i===current);b.setAttribute('aria-pressed',String(i===current))});
    };
    thumbs.forEach((button,index)=>button.addEventListener('click',()=>setImage(index)));
    document.querySelectorAll('[data-gx-gallery-move]').forEach(button=>button.addEventListener('click',()=>setImage(current+(parseInt(button.dataset.gxGalleryMove,10)||0))));
  }
  const filterToggle=document.querySelector('[data-gx-filter-toggle]');
  if(filterToggle)filterToggle.addEventListener('click',()=>{
    const panel=document.getElementById('gx-filters-panel');if(!panel)return;
    const expanded=filterToggle.getAttribute('aria-expanded')==='true';
    filterToggle.setAttribute('aria-expanded',String(!expanded));panel.classList.toggle('is-open',!expanded);
  });
  const tabs=[...document.querySelectorAll('[data-gx-tab]')];
  tabs.forEach(button=>button.addEventListener('click',()=>{
    const key=button.dataset.gxTab;
    tabs.forEach(t=>{t.classList.toggle('is-active',t===button);t.setAttribute('aria-selected',String(t===button));t.tabIndex=t===button?0:-1});
    document.querySelectorAll('[data-gx-panel]').forEach(panel=>{panel.hidden=panel.dataset.gxPanel!==key});
  }));
  const allButton=document.querySelector('[data-gx-add-all]');
  if(allButton){
    const forms=[...document.querySelectorAll('.gx-addon-form')];
    allButton.hidden=forms.length<2;
    allButton.addEventListener('click',async()=>{
      const items=forms.map(form=>({id:Number(form.querySelector('[name="id"]')?.value),quantity:1})).filter(item=>item.id>0);
      if(!items.length)return;
      allButton.disabled=true;const old=allButton.textContent;allButton.textContent='Adding extras…';
      try{
        const response=await fetch(cartUrl+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||'Unable to add extras')}
        await refreshCart();announce('Your extras are in the basket ♡');
      }catch(error){announce(error.message||'Unable to add extras',true)}
      finally{allButton.disabled=false;allButton.textContent=old}
    });
  }
})();
(() => {
const menu=document.querySelector('#primary-menu');if(!menu)return;
const entries=[...menu.querySelectorAll('.nav-item')].filter(item=>item.querySelector('.mega-menu'));
const closeAll=except=>{entries.forEach(item=>{if(item===except)return;item.classList.remove('gx-menu-open');item.querySelector(':scope > a')?.setAttribute('aria-expanded','false')})};
entries.forEach(item=>{
const link=item.querySelector(':scope > a');const panel=item.querySelector('.mega-menu');if(!link||!panel)return;
link.setAttribute('aria-haspopup','true');link.setAttribute('aria-expanded','false');
let closeTimer;
const open=()=>{clearTimeout(closeTimer);closeAll(item);item.classList.add('gx-menu-open');link.setAttribute('aria-expanded','true')};
const close=()=>{if(!item.matches(':hover')&&!item.contains(document.activeElement)){item.classList.remove('gx-menu-open');link.setAttribute('aria-expanded','false')}};
item.addEventListener('pointerenter',open);
item.addEventListener('pointerleave',()=>{clearTimeout(closeTimer);closeTimer=setTimeout(close,250)});
item.addEventListener('focusin',open);
item.addEventListener('focusout',()=>{clearTimeout(closeTimer);closeTimer=setTimeout(close,100)});
panel.addEventListener('pointerenter',()=>clearTimeout(closeTimer));
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){closeAll();if(menu.contains(document.activeElement))document.activeElement?.blur()}});
document.addEventListener('pointerdown',event=>{if(!menu.contains(event.target))closeAll()});
})();